import { PaintedScene } from '../PaintedScene';

export const WIND_CHIME_HOLLOW_PHASER_KEY = 'WindChimeHollowScene' as const;
export const WIND_CHIME_HOLLOW_MANIFEST_KEY = 's-205-wind-chime-hollow' as const;

export class WindChimeHollowScene extends PaintedScene {
  constructor() {
    super(WIND_CHIME_HOLLOW_PHASER_KEY, WIND_CHIME_HOLLOW_MANIFEST_KEY);
  }
}
